import React, { useEffect, useState } from 'react';
import '../../Styles/Taetigkeitsbericht/verortung.css';
import ImageSliderComponent from './ImageSliderComponent';
import { getToken } from '../../Utils/Common';
import ImagePreview from '../ImagePreview';

function Verortung(props) {
    const [verortungImages, setVerortungImages] = useState([]);
    const [updatedImages, setUpdatedImages] = useState([]);
    const [previewImage, setPreviewImage] = useState('');
    const [previewShown, setPreviewShown] = useState(false)
    async function getCDNImages() {
        let theCDNImages = [];
        let theCDNImagesURLs = [];

        if (props.verortungData !== undefined) {
            theCDNImages = await Promise.all(
                props.verortungData?.map(async (item) => {
                    const response = await fetch(
                        process.env.REACT_APP_BACKEND_API_URI + 'mobileappbackend/getpresignedurl',
                        {
                            method: 'POST',
                            headers: {
                                'Content-type': 'application/json'
                            },
                            body: JSON.stringify({
                                token: getToken(),
                                data: { object_path: item.url }
                            })
                        }
                    );

                    return await response.json();
                })
            );

            theCDNImages.forEach((item) => theCDNImagesURLs.push(item.url));
        }
        return theCDNImagesURLs;
    }

    useEffect(async () => {
        let retrievedImages = [];
        retrievedImages = await getCDNImages();
        setVerortungImages(retrievedImages);
    }, [props.verortungData]);

    useEffect(() => {
        let updatedTaetigkeitsberichtData = props.taetigkeitsberichtData;
        let updatedVerortungData = [];

        updatedImages.forEach((image) => {
            updatedTaetigkeitsberichtData.verortung.forEach((item) => {
                if (item.url === image) {
                    updatedVerortungData.push(item);
                }
            });
        });

        updatedTaetigkeitsberichtData.verortung = updatedVerortungData;
        props.setTaetigkeitsberichtData(updatedTaetigkeitsberichtData);
    }, [updatedImages]);

    return (
        <div>
            {verortungImages?.length === 0 ? (
                <label className="handwai-text-label-normal">{'Keine Bilder vorhanden'}</label>
            ) : (
                verortungImages?.length > 0 && (
                    <ImageSliderComponent
                        type={'verortung'}
                        setIsChange={props.setIsChange}
                        isOrigin={!props.originState}
                        images={verortungImages}
                        setImages={setVerortungImages}
                        width={'100%'}
                        height={'50vh'}
                        setUpdatedImages={setUpdatedImages}
                        setPreviewImage={setPreviewImage}
                        setPreviewShown={setPreviewShown}
                    />
                )
            )}
            {previewShown && (
                <ImagePreview
                    previewImage={previewImage}
                    setPreviewShown={setPreviewShown}
                />
            )}
        </div>
    );
}

export default Verortung;
